import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SEOLink = styled(Link)`
  color: #000;
  &:hover {
    border-color: #ee3932 !important;
    color: #ee3932 !important;
  }
`;

export const SEOLinkWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 5px;
  justify-content: space-evenly;
  border-top: 1px solid;
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
`;

export default SEOLink;
